import api from "../../Api";
import { BaseService } from "../../BaseService";


const URL = 'access/pages';

export class AccessPageService extends BaseService {
    async list(params: any): Promise<any[]> {
        try {
            return this.handleResponse(await api.post(`${URL}/list`, params));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async fetch(params: any): Promise<any> {
        try {
            if (params?.id) {
                return this.handleResponse(await api.put(`${URL}/update`, params));
            } else {
                return this.handleResponse(await api.post(`${URL}/create`, params));
            }
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async delete(id: number): Promise<any> {
        try {
            return this.handleResponse(await api.delete(`${URL}/delete/${id}`));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}